import { render, staticRenderFns } from "./WhsD.vue?vue&type=template&id=045c7606"
import script from "./WhsD.vue?vue&type=script&lang=js"
export * from "./WhsD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports